/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Alternatives_Empty_DescInputs */

const en_directory_alternatives_empty_desc = /** @type {(inputs: Directory_Alternatives_Empty_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is currently the only published tool in its category. Browse related categories, or submit a similar tool to the directory.`)
};

const zh_directory_alternatives_empty_desc = /** @type {(inputs: Directory_Alternatives_Empty_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 目前是该分类下唯一收录的工具。可以浏览相关分类，或提交一个类似的工具。`)
};

/**
* | output |
* | --- |
* | "{name} is currently the only published tool in its category. Browse related categories, or submit a similar tool to the directory." |
*
* @param {Directory_Alternatives_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_empty_desc = /** @type {((inputs: Directory_Alternatives_Empty_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_Empty_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_empty_desc(inputs)
	return zh_directory_alternatives_empty_desc(inputs)
});
export { directory_alternatives_empty_desc as "directory.alternatives.empty_desc" }